import React, { useRef, useState } from 'react';

import ModalPopup, { ModalPopupInterface } from '../../elements/ModalPopup';
import confirmationAlert from '../../elements/alerts/confirmationAlert';
import FormGroup from '../../elements/formElements/FormGroup';
import SubmitButton from '../../elements/formElements/SubmitButton';

import CRMApi from 'Api/CRM/CRMApi';
import SweetAlert from 'crm/elements/alerts/SweetAlert';
import handleValidationErrors, { ValidationErrors } from 'crm/helpers/ResponseErrorHelper';

type Props = Readonly<{ userId: number; onSuccess: Function }>;

function ManualWithdrawModal({ userId, onSuccess }: Props) {
    const [withdrawalObject, setWithdrawalObject] = useState({ amount: '0' });
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState<ValidationErrors>({});
    const modalRef = useRef<ModalPopupInterface>();

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        setIsLoading(true);
        event.preventDefault();
        confirmationAlert({
            title: 'Are you sure to add manual withdrawal?',
            onConfirm: addManualWithdraw,
            onCancel: () => setIsLoading(false),
        });
    }

    function addManualWithdraw() {
        CRMApi.post(`user/${userId}/withdrawals/add_manual`, withdrawalObject)
            .then((response) => {
                if (response?.data && !response.data.validate_failure) {
                    SweetAlert.success('Successfully added manual withdrawal.');
                    onSuccess();
                    modalRef.current.closeModal();
                    setWithdrawalObject({ amount: '0' });
                    setErrors({});
                } else {
                    SweetAlert.error('Something went wrong...');
                }
            })
            .catch((error) => handleValidationErrors(error, setErrors))
            .finally(() => setIsLoading(false));
    }

    const getContent = () => (
        <form onSubmit={handleSubmit} autoComplete="do-not-autofill">
            <FormGroup
                type="number"
                field="amount"
                value={withdrawalObject.amount}
                label="Amount"
                error={errors.amount?.[0]}
                min={1}
                handleChange={(event) => setWithdrawalObject({ amount: event.target.value })}
            />
            <SubmitButton label="Add manual withdrawal" isLoading={isLoading} />
        </form>
    );

    return (
        <ModalPopup
            buttonContent="Add Manual Withdraw"
            modalTitle="Add Manual Withdraw"
            modalContent={getContent()}
            buttonClass="btn-primary btn-sm mr-2"
            ref={modalRef}
        />
    );
}

export default ManualWithdrawModal;
